import { render, staticRenderFns } from "./FamilyRecord.vue?vue&type=template&id=b119d250&scoped=true&"
import script from "./FamilyRecord.vue?vue&type=script&lang=js&"
export * from "./FamilyRecord.vue?vue&type=script&lang=js&"
import style0 from "./FamilyRecord.vue?vue&type=style&index=0&id=b119d250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b119d250",
  null
  
)

export default component.exports